import { motion } from "framer-motion";
import { Brain, ShieldCheck, Gauge, Lock, BarChart3 } from "lucide-react";

const features = [
  { icon: Brain, title: "Intelligent Discovery", description: "Discover startups and investors aligned with your thesis, stage, and sector." },
  { icon: ShieldCheck, title: "Structured & Vetted Profiles", description: "Detailed profiles and onboarding ensure credible founders and investors." },
  { icon: Gauge, title: "Efficient Review", description: "Review startup opportunities in minutes, not weeks." },
  { icon: Lock, title: "Privacy by Design", description: "Control what you share and when you share it." },
  { icon: BarChart3, title: "Engagement Insights", description: "Track profile views, investor activity, and deal progress in real time." },
];

const Features = () => {
  return (
    <section id="features" className="py-24 md:py-32 bg-muted/30" aria-label="Platform features">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
            Built for <span className="text-gradient">Speed & Trust</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Discover startups, review opportunities, and start conversations, all in one platform.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((feat, i) => (
            <motion.div
              key={feat.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="glass rounded-xl p-6 group hover:border-primary/30 transition-colors"
            >
              <feat.icon className="w-6 h-6 text-primary mb-4" aria-hidden="true" />
              <h3 className="font-display font-semibold mb-2">{feat.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{feat.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
